import axios from 'axios';
import { AppConfig, JWT } from '../config';
import { WorkScheduleConstant } from './constants/WorkScheduleConstant';
import { AlertAction } from './AlertAction';
import { Translate as t } from '../config/Translate';

const GetMySchedule = (yearMonth) => async (dispatch) => {
	dispatch({ type: WorkScheduleConstant.LOADING });
	try {
		const data = { type: 'getMySchedule', data: { yearMonth } };
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/workschedule', data, JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: WorkScheduleConstant.GET_MY_SUCCESS, payload: ret.data.data });
			if (yearMonth) {
				dispatch({ type: WorkScheduleConstant.SET_YEAR_MONTH, payload: yearMonth });
			}
		} else {
			dispatch({ type: WorkScheduleConstant.GET_MY_FAIL });
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch({ type: WorkScheduleConstant.GET_MY_FAIL });
	}
	dispatch({ type: WorkScheduleConstant.LOADED });
};

const SaveMyBase = (saveData, yearMonth) => async (dispatch) => {
	dispatch({ type: WorkScheduleConstant.LOADING });
	try {
		const data = { type: 'saveMyBase', data: saveData };
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/workschedule', data, JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: WorkScheduleConstant.SAVE_BASE_SUCCESS });
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch(GetMySchedule(yearMonth));
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: WorkScheduleConstant.LOADED });
};

const ResetMyBase = (yearMonth) => async (dispatch) => {
	dispatch({ type: WorkScheduleConstant.LOADING });
	try {
		const data = { type: 'resetMyBase' };
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/workschedule', data, JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: WorkScheduleConstant.RESET_BASE_SUCCESS });
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch(GetMySchedule(yearMonth));
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: WorkScheduleConstant.LOADED });
};

const AddOverrideRange = (overrideData, yearMonth) => async (dispatch) => {
	dispatch({ type: WorkScheduleConstant.LOADING });
	try {
		const data = { type: 'addOverrideRange', data: overrideData };
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/workschedule', data, JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: WorkScheduleConstant.ADD_OVERRIDE_RANGE_SUCCESS });
			dispatch(AlertAction.Success(t('common.message.success.saved')));
			dispatch(GetMySchedule(yearMonth));
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: WorkScheduleConstant.LOADED });
};

const DeleteOverride = (_id, yearMonth) => async (dispatch) => {
	dispatch({ type: WorkScheduleConstant.LOADING });
	try {
		const data = { type: 'deleteOverride' };
		const ret = await axios.post(AppConfig.API_SERVER_PATH + '/workschedule/' + _id, data, JWT());
		if (ret.data.status == 'success') {
			dispatch({ type: WorkScheduleConstant.DELETE_OVERRIDE_SUCCESS });
			dispatch(AlertAction.Success(t('common.message.deleted')));
			dispatch(GetMySchedule(yearMonth));
		} else {
			dispatch(AlertAction.Error(ret.data));
		}
	} catch (error) {
		dispatch(AlertAction.Error(error));
	}
	dispatch({ type: WorkScheduleConstant.LOADED });
};

export const WorkScheduleAction = {
	GetMySchedule,
	SaveMyBase,
	ResetMyBase,
	AddOverrideRange,
	DeleteOverride,
};
